import { useSelector } from 'react-redux'
import { IConfigSeller } from '@/models/configSeller'

/**
 * Lee el seller actualmente seleccionado en el config store.
 * Devuelve null si no hay seller cargado (idSeller=0 cuenta como no cargado).
 *
 * Equivalente al patrón usado en el resto del app:
 *   const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
 *   const selectedSeller = configSeller.config ? configSeller.config.idSeller : null
 */
export const useSelectedSeller = (): number | null => {
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const id = configSeller.config?.idSeller ?? 0
  return id > 0 ? id : null
}
